module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_3009.af4429b5.png";